import { render, staticRenderFns } from "./OnboardingTypeStep.vue?vue&type=template&id=cf82edf0&scoped=true"
import script from "./OnboardingTypeStep.vue?vue&type=script&lang=js"
export * from "./OnboardingTypeStep.vue?vue&type=script&lang=js"
import style0 from "./OnboardingTypeStep.vue?vue&type=style&index=0&id=cf82edf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf82edf0",
  null
  
)

export default component.exports